import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import DashBoardLayerOne from "../components/DashBoardLayerOne";

const HomePageOne = () => {
  return (
    <MasterLayout>
      <DashBoardLayerOne />
    </MasterLayout>
  );
};

export default HomePageOne;
